import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { createSearchParams, useNavigate } from "react-router-dom";
import { SizeGuideServices, StorageServices } from "../../../../services";
import {
  MainBoxTool,
  DataTableSizeGuides,
  ModalCommon,
  SelectSizeGuideType,
  SelectGender,
  GuideTemplate,
  ModalLimitReached,
} from "../../../common";
import "./DashboardSizeGuides.css";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan } from "@fortawesome/free-solid-svg-icons";
import { Tools } from "../../../../misc";

//interface RowData {
//  StorePlan: "Free" | "Pro" | "Enterprise";
//  Status: "Active" | "Inactive";
//}

//interface DashboardSizeGuidesProps {
//  elements: RowData[];
//  storePlan: keyof typeof ACTIVE_GUIDE_LIMITS;
//}

//const ACTIVE_GUIDE_LIMITS = {
//  Free: 4,
//  Pro: 7,
//  Enterprise: Infinity,
//};

const DashboardSizeGuides = () => {
  const [elements, setElements] = useState([{}]);
  const [isLoadingElements, setIsLoadingElements] = useState(false);
  const [elementSelection, setElementSelection] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showLimitModal, setShowLimitModal] = useState(false);
  const [clothesType, setClothesType] = useState(0);
  const [clothesTypeSelect, setClothesTypeSelect] = useState(0);
  const [genderSelect, setGenderSelect] = useState(0);
  const [uniqueSelect, setUniqueSelect] = useState(false);

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenLimitModal = () => {
    setShowLimitModal(true);
  };

  const handleCloseLimitModal = () => {
    setShowLimitModal(false);
  };

    const getActiveSizeGuides = (items: any[] | null = null) => {
        let qActive: number = 0;

        if (Tools.IsDevelopment()) console.log('getActiveSizeGuides', items);

        try {
            if (items) {
                qActive = items.filter((item: any) => {
                    return (item.Enabled);
                }).length || 0;
            } else {
                qActive = elements.filter((element: any) => {
                    return (element.Enabled);
                }).length || 0;
            }
        } catch (e) {
            console.log("ERROR getActiveSizeGuides", e);
        }
        return qActive || 0;
    }

  const onOkModal = () => {
    //const activeGuidesCount = calculateActiveGuides(props.storePlan);

    if (!(Tools.CanCreateSizeGuide())) {
      handleOpenLimitModal();
    } else {
      setShowModal(false);

      // console.log('TIPO SELECCIONADO', clothesTypeSelect);
      // console.log('GENERO SELECCIONADO', genreSelect);
      // console.log('UNICO SELECCIONADO', uniqueSelect);

      navigate({
        pathname: "add",
        search: createSearchParams({
          clothesType: clothesTypeSelect.toString(),
          gender: genderSelect.toString(),
          isUnique: uniqueSelect.toString(),
        }).toString(),
      });
    }
  };

  const onHideModal = () => {
    setShowModal(false);
    setShowLimitModal(false);
  };

  const ModalContent = () => {
    return (
      <>
        <Form>
          <SelectSizeGuideType
            Label={
              <FormattedMessage
                id="ready-size-clothing-type"
                defaultMessage="Tipo de prenda"
              />
            }
            DefaultValue={clothesType}
            SuscribedChange={(value: number) => setClothesTypeSelect(value)}
          />
          <SelectGender
            Label="ready-size-gender"
            ClassGroup={"mt-3"}
            DefaultValue={2}
            Disabled={clothesType === 4}
            SuscribedChange={(value: number) => setGenderSelect(value)}
          />
          <Form.Group className="justify-content-center mt-3">
            <Form.Check
              type="checkbox"
              label={
                <FormattedMessage
                  id="ready-size-unique-size"
                  defaultMessage="Talle único"
                />
              }
              onChange={(e) => setUniqueSelect(e.target.checked)}
              defaultChecked={false}
              disabled={clothesType === 4}
            />
          </Form.Group>
        </Form>
      </>
    );
  };

  const ModalLimitContent = () => {
    return (
      <Form>
        <div className="sizeguide-limitreached-container">
          <p>
            Has alcanzado el límite de guías disponible para tu plan, para
            expandirlo contáctate con
          </p>
          <a href="mailto:hello@readysize.ai">hello@readysize.ai</a>
        </div>
      </Form>
    );
  };

  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        setIsLoadingElements(true);

        const response = await SizeGuideServices.GetSizesGuides();

        if (response.Status === 200) {
          //console.log("RESPONSE SIZE GUIDE", response);
            Tools.SetQuantitySizeGuideActive(getActiveSizeGuides(response.Content));
            setElements(response.Content);
        }

        setIsLoadingElements(false);
      } catch (error) {
        console.log(error);

        setIsLoadingElements(false);
      }
    })();
  }, [setElements]);

  const onSuscribeElementSelectionChange = (value: any) => {
    setElementSelection(value);

    // console.log('Elementos Seleccionados', elementSelection);
  };

  const onSuscribeDuplicate = (data: any) => {
    console.log("Click Duplicar", data);
  };

  const onSuscribeDelete = (data: any) => {
    console.log("Click Borrar", data);
  };

  const onSuscribeEdit = (data: any) => {
    // console.log('Click Editar', data);

    navigate(
      {
        pathname: `edit/${data.Id}`,
        // search: createSearchParams({
        //   clothesType: clothesTypeSelect.toString(),
        //   gender: genderSelect.toString(),
        //   isUnique: uniqueSelect.toString(),
        // }).toString(),
      },
      { state: data }
    );
  };

  const onSuscribeDeleteGroup = (data: any) => {
    console.log("Click Eliminar Guías", data);
  };

  const onSuscribeDownloadData = (data: any) => {
    console.log("Click Download", data);
  };

  /* IMG 1 */
  const imgSrc1 = "img/upperclothingimg.png";
  const paragraphText1 = (
    <FormattedMessage
      id="size-guide-upper-clothing"
      defaultMessage="Prendas Superiores"
    />
  );
  /* IMG 2 */
  const imgSrc2 = "img/bottomwear.png";
  const paragraphText2 = (
    <FormattedMessage
      id="size-guide-lower-clothing"
      defaultMessage="Prendas Inferiores"
    />
  );
  /* IMG 3 */
  const imgSrc3 = "img/dressimg.png";
  const paragraphText3 = (
    <FormattedMessage
      id="size-guide-full-clothing"
      defaultMessage="Prendas Enteras"
    />
  );
  /* IMG 4 */
  const imgSrc4 = "img/braimg.png";
  const paragraphText4 = (
    <FormattedMessage id="ready-size-bras" defaultMessage="Sostenes" />
  );
  /* IMG 5 */
  const imgSrc5 = "img/shoeimg2.png";
  const paragraphText5 = (
    <FormattedMessage id="ready-size-footwear" defaultMessage="Calzado" />
  );

  const colStyle = {
    marginBottom: "30px",
  };

  const contentInternalMainBox = () => {
    return (
      <>
        <Row className="p-3">
          <Col md={6} xl={4} style={colStyle}>
            <GuideTemplate
              imgSrc={imgSrc1}
              paragraphText={paragraphText1}
              onClick={() => onInitSizeGuideTemplate(1)}
              mainContainerClass="guide-template-main-container"
              imageContainerClass="guide-template-imagecontainer"
              imageClass="guide-temaplate-image"
              textContainerClass="guide-template-textcontainer"
              textClass="guide-template-text"
            />
          </Col>

          <Col md={6} xl={4} style={colStyle}>
            <GuideTemplate
              imgSrc={imgSrc2}
              paragraphText={paragraphText2}
              onClick={() => onInitSizeGuideTemplate(2)}
              mainContainerClass="guide-template-main-container"
              imageContainerClass="guide-template-imagecontainer"
              imageClass="guide-temaplate-image"
              textContainerClass="guide-template-textcontainer"
              textClass="guide-template-text"
            />
          </Col>

          <Col md={6} xl={4} style={colStyle}>
            <GuideTemplate
              imgSrc={imgSrc3}
              paragraphText={paragraphText3}
              onClick={() => onInitSizeGuideTemplate(3)}
              mainContainerClass="guide-template-main-container"
              imageContainerClass="guide-template-imagecontainer"
              imageClass="guide-temaplate-image"
              textContainerClass="guide-template-textcontainer"
              textClass="guide-template-text"
            />
          </Col>

          <Col md={6} xl={4} style={colStyle}>
            <GuideTemplate
              imgSrc={imgSrc4}
              paragraphText={paragraphText4}
              onClick={() => onInitSizeGuideTemplate(4)}
              mainContainerClass="guide-template-main-container"
              imageContainerClass="guide-template-imagecontainer"
              imageClass="guide-temaplate-image"
              textContainerClass="guide-template-textcontainer"
              textClass="guide-template-text"
            />
          </Col>

          <Col md={6} xl={4} style={colStyle}>
            <GuideTemplate
              imgSrc={imgSrc5}
              paragraphText={paragraphText5}
              onClick={() => onInitSizeGuideTemplate(5)}
              mainContainerClass="guide-template-main-container"
              imageContainerClass="guide-template-imagecontainer"
              imageClass="guide-temaplate-image"
              textContainerClass="guide-template-textcontainer"
              textClass="guide-template-text"
            />
          </Col>
        </Row>
      </>
    );
  };

  const onInitSizeGuideTemplate = (idType: number) => {
    setClothesType(idType);

    setClothesTypeSelect(idType);
    setGenderSelect(2);
    setUniqueSelect(false);

    setShowModal(true);
  };

  return (
    <>
      {/* Access */}
      <Row className="justify-content-center">
        <Col xl={7} className="sizeguide-template-main">
          <MainBoxTool
            title={
              <FormattedMessage
                id="size-guide-select-template"
                // defaultMessage="Selecciona una plantilla"
              />
            }
            children={contentInternalMainBox()}
          />
        </Col>
      </Row>

      {/* Size Guides */}
      <Row className="justify-content-center mt-5">
        <Col>
                  {/*handlerDelete={onSuscribeDelete}*/}
                  {/*handlerClone={onSuscribeDuplicate}*/}
          <DataTableSizeGuides
            elements={elements}
            isLoading={isLoadingElements}
            scrollHeight={"flex"}
            handlerSelectionRow={onSuscribeElementSelectionChange}
            
            handlerEdit={onSuscribeEdit}
           
            handlerDeleteGroup={onSuscribeDeleteGroup}
            handlerDownload={onSuscribeDownloadData}
            showTitle={true}
          />
        </Col>
      </Row>

      {/* Modal Template */}
      <ModalCommon
        Title="ready-size-new-size-guide"
        buttonSuccessTitle="ready-size-create"
        Show={showModal}
        OnModalClose={onHideModal}
        OnModalOk={onOkModal}
        Content={ModalContent()}
      />
      <ModalCommon
        Title="readysize-limit-title"
        buttonSuccessTitle="readysize-contact"
        Show={showLimitModal}
        OnModalClose={onHideModal}
        OnModalOk={onHideModal}
        Content={ModalLimitContent()}
      />
    </>
  );
};

export default DashboardSizeGuides;
